<script>
    import dayjs from 'dayjs';

    export let course;

</script>

{#if course.multi_day === false}

    <span class='fas fa-clock'></span> { dayjs(course.start).format('H:mm A')} - { dayjs(course.end).format('H:mm A')}

{:else}

    <span class='fas fa-clock'></span> { dayjs(course.start).format('H:mm A')} - { dayjs(course.end).format('dddd MMMM H:mm A')}

{/if}